module.exports = __webpack_public_path__ + "static/media/clear-sky.8cf8b1b9.svg";